import { useState } from 'react';
import { IDataGridColumn } from 'components/data-grid/model';
import { apiStatic, requestError, useI18n } from 'AurionCR/components';
import { ModuleExportExcel } from './export-excel';
import { gidColumnsToExcel, queryEncoderObject } from '../helpers';
import { notifyRequestResult } from 'AurionCR/store/modules/notify';
import { useDispatch } from 'react-redux';

export const useExportToExcel = () => {
  const [loading, setLoading] = useState(false);
  const { t } = useI18n();

  const dispatch = useDispatch();
  const exportToExcel = async ({
    url,
    params,
    columns,
    title,
  }: {
    url: string;
    params: any;
    columns: IDataGridColumn[];
    title: string;
  }) => {
    setLoading(true);
    try {
      const { data } = await apiStatic.post(url, queryEncoderObject(params));
      const excelColumns = gidColumnsToExcel(columns);
      const _columns = excelColumns.map((item) => ({ ...item, title: t(item.title) }));
      const { wb_out } = await ModuleExportExcel.export({
        columns: _columns,
        data: data.value,
        settings: { title },
      });
      await ModuleExportExcel.save({ wb_out, name: title });
      dispatch(notifyRequestResult('success'));
    } catch (e: any) {
      dispatch(notifyRequestResult(requestError(e.e.message), 'error'));
    } finally {
      setLoading(false);
    }
  };

  return {
    exportToExcel,
    loading,
  };
};
